import { TReduxActions } from '../../../types/redux';
import { TName } from '../../../types/newReview';
import { ENewAnswerForm } from '../../../actions/newAnswer/newAnswearAction';
import { ENameActionTypes } from '../../../actions/newAnswer/nameActions';

export const defaultValue = {
  value: null,
};

export function nameAnswerReducer(state: TName = defaultValue, { type, payload }: TReduxActions): TName {
  if (type === ENameActionTypes.SetName) {
    return {
      value: payload as string,
    };
  }

  if (type === ENewAnswerForm.Clear) {
    return defaultValue;
  }

  return state;
}
